<template>
    <!-- -->
    <div class="distributed">
        <Head :index="'4'"></Head>
        <div class="chartTop">
            <div class="fl">
                <el-button @click="tabClass('table')" :class="{ active: type == 'table' }" type="text" size="big" class="button">列表</el-button>
                <el-button @click="tabClass('map')" :class="{ active: type == 'map' }" type="text" size="big">地图</el-button>
            </div>
            <div class="fr">
                
            </div>
        </div>
        <div v-if="type == 'table'" style="width: 100%;height:100%">
            <el-table :data="tableData" border :span-method="objectSpanMethod1" style="width: 1320px;height:calc(100% - 115px)">
                <el-table-column prop="name" width="80" label="姓名"></el-table-column>
                <el-table-column prop="shixu" width="70" label="世序"></el-table-column> 
                <el-table-column prop="fromaddress" width="350" label="迁出地"></el-table-column>
                <el-table-column prop="toaddress" width="350" label="迁入地"></el-table-column>
                <el-table-column prop="migrationdate" width="270" label="迁徙时间"></el-table-column>
                <el-table-column prop="migrationreasons" width="200" label="迁徙原因"></el-table-column>
            </el-table>
        </div>
        <div v-else class="amap-page-container">
            <div class="btnF" v-if="showFlag" @click="showFun(false)">收起</div>
            <div class="btnF btnShow" v-if="!showFlag" @click="showFun(true)">展开</div>
            <div class="checkbox-group" v-if="showFlag">
                <div style="border-bottom: 2px solid #8c939d;padding-left:0px;padding-top:40px ;font-weight:bold" >
                    <!-- <el-checkbox v-model="isCheckboxChecked" @change="handleCheckboxChange">自动滚动显示</el-checkbox>
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">显示全部 
                    </el-checkbox>-->
                    <el-radio-group v-model="isCheckChecked" @change="handleChangeCheck">
                        <el-radio :label="1" style="font-weight:bold">自动滚动显示</el-radio>
                        <el-radio :label="2" style="font-weight:bold">显示全部</el-radio>
                    </el-radio-group>
                </div>
                <div  style="margin: 15px 0;"></div>
                <el-radio-group  ref="radioGroup" v-model="checkList" v-if="showFlag" @change="handleCheckedCitiesChange">
                    <el-radio v-for="(item, index) in checkData" :label="index" :key="index"
                    >{{ item.name.split("|")[0] + " (" + item.name.split("|")[1] + ")" }}
                    </el-radio>
                </el-radio-group>
               
            </div>
            <div class="amap-page-container">
                <el-amap :zoom="zoom" :center="center" view-mode="3D" :pitch="0" :show-label="true" class="amap-demo">
                <el-amap-loca @init="initLoca">
                    <el-amap-loca-pulse-line
                    :visible="visible"
                    @click="eventsFun"
                    :depth="true"
                    :source-data="sourceData"
                    :layer-style="layerStyle"
                    ></el-amap-loca-pulse-line>
                </el-amap-loca>
                </el-amap>
            </div>
        </div>

        <ul class="ry" v-show="liData.length != 0">
            <li v-for="(item, index) in liData" :key="index">
                <p>{{ item.names }}</p>
                <p>迁出地：{{ item.fromName }}</p>
                <p>迁入地：{{ item.toName }}</p>
            </li>
        </ul>
    </div>
</template>

<script>
import Head from "@/components/header.vue";
import api from "@/request/api";
var headColors = ["#ECFFB1", "#146968", "#146968", "#146968", "#146968", "#146968", "#146968", "#146968"];
var trailColors = [
    "rgba(255,178,6, 0.2)",
    "rgba(255,178,6, 0.2)",
    "rgba(20,105,104, 0.2)",
    "rgba(20,105,104, 0.2)",
    "rgba(20,105,104, 0.2)",
    "rgba(20,105,104, 0.2)",
    "rgba(20,105,104, 0.2)",
    "rgba(20,105,104, 0.2)"
];
export default {
    data() {
        let self = this;
        return {
            showFlag:true,
            zoom: 3,
            center: [109.595668, 35.447184],
            visible: true,
            sourceData: {},
            checkData: {},
            checkList: "",
            checkAll: false,
            isIndeterminate: false,
            layerStyle: {
                altitude: 0,
                lineWidth: (_, feature) => 4,
                headColor: (_, feature) => "red",
                showDir: true,
                // headColor: (_, feature) => headColors[feature.properties.type],
                trailColor: (_, feature) => "#ECFFB1",
                // trailColor: (_, feature) => trailColors[feature.properties.type],
                interval: 0.5,
                duration: 10000
            },
            lines: [],
            liData: [],
            type: "map",
            tableData: [],
            isCheckboxChecked: false, // 复选框是否选中
            isCheckChecked:'0',
            currentIndex: 0, // 当前选中的radio索引
            timer: null // 定时器
        };
    },
   
    created() {
        this.$message({
            message: "可以使用双指捏合放大缩小地图",
            // duration: 2000,
        });
        // let self = this;
        // let basePosition = [];
        // ///getancestorarea
        api.familyGet(localStorage.getItem("fid")).then((res) => {
            if (res.data.coordinate == "") {
                this.center = [116.367827, 40.0865];
            } else {
                this.center = res.data.coordinate.split(", ");
            }
        });
        api.migrateToByName({id: localStorage.getItem("fid"), type: 1}).then((res) => {
         this.checkData = res.data;
        });

        api.migrateToByName({id: localStorage.getItem("fid"), type: 0}).then((res) => {
            for (var i = 0; i < res.data.length; i++) {
                for (var s = 0; s < res.data[i].datas.length; s++) {
                this.tableData.push(res.data[i].datas[s]);
                }
            }
        });
    },

    methods: {
        showFun(flag){
            this.showFlag=flag
        },
        handleChangeCheck(value){
        //   console.log(value,'----value')  
        //   console.log(this.isCheckChecked,'----isCheckChecked')  
          if(value==1){//自动展示
            this.isCheckboxChecked=true
            this.handleCheckboxChange()

          }else if(value==2){//显示全部
            this.handleCheckAllChange(true) 
          }
        },
        handleCheckboxChange() {
            this.liData=[]
            this.sourceData={}
            var that = this;
            if (this.isCheckboxChecked) {
                // 复选框选中时开始轮流选中radio
                let ind = 0;
                this.timer = setInterval(function () {
                that.checkList = ind;
                that.handleCheckedCitiesChange(ind);
                if (ind < that.checkData.length) {
                    ind = ind + 1;
                } else {
                    clearInterval(this.timer);
                }
                }, 1000); // 每秒钟选中下一个radio
            } else {
                // 复选框取消选中时停止轮流选中radio
                clearInterval(this.timer);
            }
        },
        handleCheckAllChange(val) {
            // console.log(val,'----val')
            clearInterval(this.timer);//关闭定时器，用于切换自动展示切回来时关闭自动滚动问题
            this.liData=[]
            let options = [];
            let data = [];
            for (let i = 0; i < this.checkData.length; i++) {
                options.push(i);
                if (val) {
                let arr = [];
                for (let j = 0; j < this.checkData[i].datas.length; j++) {
                    arr.push(this.checkData[i].datas[j].coords[0]);
                    arr.push(this.checkData[i].datas[j].coords[1]);
                }

                data.push({
                    type: "Feature",
                    name: this.checkData[i].name,
                    geometry: {
                    type: "LineString",
                    coordinates: arr,
                    fromName: this.checkData[i].datas[0].fromaddress,
                    names: this.checkData[i].datas[0].name,
                    toName: this.checkData[i].datas[0].toaddress
                    }
                });
                }
            }
            this.checkList = val ? options : [];
            this.isIndeterminate = val;
            this.sourceData = {
                type: "FeatureCollection",
                features: data
            };
            this.$forceUpdate();
        },
        handleCheckedCitiesChange(value) {
        this.liData=[]
        let options = [];
        let data = [];
        for (let i = 0; i < this.checkData.length; i++) {
            if (i == value) {
            let arr = [];
            for (let c = 0; c < this.checkData[i].datas.length; c++) {
                arr.push(this.checkData[i].datas[c].coords[0]);
                arr.push(this.checkData[i].datas[c].coords[1]);
            }
            data.push({
                type: "Feature",
                name: this.checkData[i].name,
                geometry: {
                type: "LineString",
                coordinates: arr,
                fromName: this.checkData[i].datas[0].fromaddress,
                names: this.checkData[i].datas[0].name,
                toName: this.checkData[i].datas[0].toaddress
                }
            });
            }
        }
        // let checkedCount = value.length;
        // this.checkAll = checkedCount > 0 && checkedCount === options.length;
        // this.isIndeterminate = checkedCount > 0 && checkedCount < options.length;

        this.sourceData = {
            type: "FeatureCollection",
            features: data
        };
        this.$forceUpdate();
        },
        eventsFun(e) {
        if (e != undefined) {
            this.liData = [e];
        }
        },
        toggleVisible() {
        this.visible = !this.visible;
        },
        initLoca(loca) {
        loca.animate.start();
        },
        tabClass(val) {
        this.type = val;
        },
        objectSpanMethod1({row, column, rowIndex, columnIndex}) {
        var data = this.tableData;
        if (columnIndex == 0) {
            let prevRow = data[rowIndex - 1]; //获取到上一条数据
            let nextRow = data[rowIndex + 1]; //下一条数据
            if (prevRow && prevRow[column.property] === row[column.property]) {
            //当有上一条数据，并且和当前值相等时
            return {rowspan: 0, colspan: 0};
            } else {
            let countRowspan = 1;
            while (nextRow && nextRow[column.property] === row[column.property]) {
                //当有下一条数据并且和当前值相等时,获取新的下一条
                nextRow = data[++countRowspan + rowIndex];
            }
            if (countRowspan > 1) {
                return {rowspan: countRowspan, colspan: 1};
            }
            }
        } else if (columnIndex == 1) {
            let prevRow = data[rowIndex - 1]; //获取到上一条数据
            let nextRow = data[rowIndex + 1]; //下一条数据
            let nowStr = row["name"] + row["shixu"];
            if (prevRow && prevRow["name"] + prevRow["shixu"] === nowStr) {
            return {rowspan: 0, colspan: 0};
            } else {
            let countRowspan = 1;
            while (nextRow && nextRow["name"] + nextRow["shixu"] === nowStr) {
                //当有下一条数据并且和当前值相等时,获取新的下一条
                nextRow = data[++countRowspan + rowIndex];
            }
            if (countRowspan > 1) {
                return {rowspan: countRowspan, colspan: 1};
            }
            }
        }
        }
    },
    components: {
        Head
    }
};
</script>
<style lang="less" scoped>
// .amap-demo {
//     height: 300px !important;
// }
.distributed {
    width: 100%;
    height: 100%;
    overflow: hidden;

    .chartTop {
        height: 55px;
        line-height: 55px;
        padding-right: 20px;
        padding-left:10px;

        .active {
            color: #ff0000;
        }

        button {
            color: #000;
        }
    }

    /deep/.el-table {
        .el-table__body-wrapper {
            overflow: auto;
            width: 100%;
            height: 100%;
        }
    }

    .amap-page-container {
        width: 100%;
        height: 100%;
        position: relative;

        // height: calc(100% - 115px);
        .checkbox-group {
            position: absolute;
            background: #fff;
            z-index: 100;
            width: 140px;
            height: 85%;
            overflow-x: auto;
            padding:0 10px;
            overflow: hidden;
            overflow-y: auto;
        }
        .btnF{
            position: absolute;
            height: 30px;
            line-height: 30px;
            width: 140px;
            background: #b2cefe;
            left: 0;
            font-size:14px;
            text-align: center;
            padding:0 10px;
            z-index:2000;
        }
        // .btnShow{
        //     // width:35px !important;
        //     // padding:0 10px;
        // }
        .search-box {
            position: absolute;
            top: 25px;
            left: 20px;
        }

        .amap-div {
            width: 100%;
            height: 100%;
            position: relative;
        }
    }
    .ry {
        width: 50%;
        overflow-y: hidden;
        background: #fff;
        max-height: calc(100vh - 120px);
        box-shadow: 0 0 8px 0 #a2a2a2;
        border-radius: 4px;
        position: absolute;
        top: 88px;
        right:10px;
        padding: 16px;
        z-index: 9;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/migrate.vue